/* Handy-Menü (Hamburger) – 05.10.2026, Inhaber am iPhone: „when I open a menu item, it doesn't scroll the page“.
   Geladen aus sections/cm-header.liquid (gehört zu assets/cm-menu.css). Nur für .cm-mobile-menu, das Desktop-Menü bleibt
   wie es ist (cm-motion.js / cm-hig.js).
   1. Seite dahinter festhalten, solange das Menü offen ist (iOS-sicher: body position:fixed, Scrollstand merken und beim
      Schließen zurück). Das Menü selbst scrollt allein (CSS in cm-menu.css: overflow + overscroll-behavior:contain).
   2. Bereich aufklappen → die anderen zu (Akkordeon) und das Menü scrollt so, dass der geöffnete Bereich oben steht
      (sanft, außer bei „Bewegung reduzieren“).
   3. Höhe: --cm-drawer-top = Oberkante des Menüs, CSS rechnet 100dvh minus diesen Wert (kein 100vh-Sprung in Safari). */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const phone = matchMedia('(max-width: 1050px)');
  const body = document.body;
  const root = document.documentElement;
  let lockedY = null;

  const lock = () => {
    if (lockedY !== null) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    root.classList.add('cm-drawer-open');
    Object.assign(body.style, { position: 'fixed', top: `-${lockedY}px`, left: '0', right: '0', width: '100%' });
  };
  const unlock = () => {
    if (lockedY === null) return;
    const y = lockedY;
    lockedY = null;
    root.classList.remove('cm-drawer-open');
    ['position', 'top', 'left', 'right', 'width'].forEach((p) => body.style.removeProperty(p));
    // ohne sanftes Scrollen zurück an die alte Stelle (html hat ggf. scroll-behavior:smooth)
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = prev;
  };

  const navOf = (menu) => menu.querySelector(':scope > nav');
  const setTop = (menu) => {
    const nav = navOf(menu);
    if (!nav) return;
    const top = Math.max(0, Math.round(nav.getBoundingClientRect().top));
    nav.style.setProperty('--cm-drawer-top', `${top}px`);
  };

  const reveal = (section) => {
    const nav = section.closest('.cm-mobile-menu > nav');
    if (!nav) return;
    const summary = section.querySelector(':scope > summary') || section;
    const target = summary.getBoundingClientRect().top - nav.getBoundingClientRect().top + nav.scrollTop - 6;
    nav.scrollTo({ top: Math.max(0, target), behavior: reduced.matches ? 'auto' : 'smooth' });
  };

  const bind = (menu) => {
    if (menu.dataset.cmDrawer) return;
    menu.dataset.cmDrawer = '1';
    menu.addEventListener('toggle', () => {
      if (menu.open && phone.matches) {
        lock();
        setTop(menu);
      } else {
        unlock();
        menu.querySelectorAll('details.cm-nav-menu[open]').forEach((d) => { d.open = false; });
      }
    });
    menu.querySelectorAll(':scope > nav details.cm-nav-menu').forEach((section) => {
      section.addEventListener('toggle', () => {
        if (!section.open) return;
        menu.querySelectorAll(':scope > nav details.cm-nav-menu[open]').forEach((d) => { if (d !== section) d.open = false; });
        // die anderen sind jetzt zu; getBoundingClientRect rechnet die Lage sofort neu (kein requestAnimationFrame nötig)
        reveal(section);
      });
    });
    // Link im Menü angetippt (auch #Anker auf derselben Seite oder ein Dialog wie „Termin buchen“): Menü zu, Seite frei
    menu.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (link && navOf(menu)?.contains(link)) menu.open = false;
    });
  };

  const init = (scope = document) => scope.querySelectorAll('.cm-mobile-menu').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Drehen / größer ziehen bis zum Desktop-Menü: Handy-Menü zu
  phone.addEventListener('change', () => {
    if (!phone.matches) document.querySelectorAll('.cm-mobile-menu[open]').forEach((m) => { m.open = false; });
    unlock();
  });
  window.addEventListener('resize', () => document.querySelectorAll('.cm-mobile-menu[open]').forEach(setTop), { passive: true });
  // Zurück-Taste (bfcache): nie mit festgehaltener Seite zurückkommen
  window.addEventListener('pageshow', () => { if (!document.querySelector('.cm-mobile-menu[open]')) unlock(); });
})();
